import React from "react";
import { unsetUser, State } from "@store";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Box, Button, Tooltip, Typography } from "@material-ui/core";
import { getMsalInstance } from "@config/entraConfig";

export const User: React.FC = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: State) => state.user);
  const onSignOutClick = async (
    event: React.SyntheticEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    if (user?.provider === "entra") {
      try {
        const msalInstance = getMsalInstance();
        await msalInstance.initialize();
        await msalInstance.logoutPopup();
      } catch (err) {
        console.log(err);
      }
    }
    dispatch(unsetUser());
  };

  return (
    <Box ml={2}>
      <Tooltip
        arrow
        title={
          <React.Fragment>
            <Box textAlign="right" p={2} color="white">
              <Typography variant="subtitle2">{user?.name!}</Typography>
              <Typography variant="caption" component="p" paragraph>
                <em>{user?.upn || user?.email}</em>
              </Typography>
              <Button
                color="inherit"
                variant="outlined"
                onClick={onSignOutClick}
              >
                Log out
              </Button>
            </Box>
          </React.Fragment>
        }
        interactive
        placement="bottom-end"
      >
        <Avatar alt={user?.name} src={user?.avatar} />
      </Tooltip>
    </Box>
  );
};
